<template>
  <div id="register">
    <h5>
      您好，您的微信号暂未与智慧体测系统绑定，请输入姓名和学号完成绑定后重新登录。
    </h5>
    <div class="form-box">
      <div class="remark">
        请认真填写以下信息，进行体测信息登记，感谢您的配合，谢谢！
      </div>
      <van-form @submit="onSubmit">
        <van-field v-model="studentName" type="text" name="姓名" label="姓名" placeholder="请输入姓名"
          :rules="[{ required: true }]" />
        <van-field v-model="snCode" type="text" name="学号" label="学号" placeholder="请输入学号"
          :rules="[{ required: true }]" />

        <div style="margin: 16px">
          <van-button round block type="info" native-type="submit">提交</van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
import { Notify } from "vant";
import { getSnCodeAndStudentName } from "@/api/common";
export default {
  name: "Register",
  components: {},
  data() {
    return {
      snCode: "",
      studentName: "",
      openId: "",
    };
  },
  created() {
    this.openId = this.$route.query.openId;
  },
  methods: {
    onSubmit() {
      getSnCodeAndStudentName({
        snCode: this.snCode,
        studentName: this.studentName,
        openId: this.openId,
      }).then(() => {
        Notify.clear();
        this.$router.push({
          path: "/registerSuccess",
        });
      })
    },
  },
};
</script>

<style scoped>
#register {
  padding: 4vw 0;
}

.form-box {
  padding: 4vw;
  font-size: 13px;
}

.remark {
  padding: 8vw 0 4vw;
}
</style>
